import { Autocomplete, Box, Chip, TextField } from '@mui/material';
import React, { useState } from 'react';
import CustomChip from '../../../../components/CustomChip';
import GenericLoader from '../../../../components/Loader/GenericLoader';
import './CommonComponentStyle.css';
import { CommonComponentLoaderAttribute } from '../../../../constants';
import LoadingButton from '@mui/lab/LoadingButton';

function CommonComponent(props) {
  const [showError, setShowError] = useState(false);
  const {
    loadData,
    loader,
    titlesList,
    setTitle,
    setTemp,
    isError,
    backToDefault,
    setIsError,
    onAddClick,
    handleDelete,
    loadingApiCall,
  } = props;
  const { name, property } = props.item;

  const handleInputChange = (event) => {
    const { value } = event.target;
    if (value !== '') {
      setTitle(value);
      setIsError(false);
    } else {
      setTitle('');
      setIsError(true);
    }
  };

  const handleClear = () => {
    setTemp(null);
    setTitle('');
  };

  const handleChange = (event, title) => {
    setTemp(title);
    setTitle('');
  };
  React.useEffect(() => {
    loadData();
  }, []);

  return (
    <div>
      {loader ? (
        <GenericLoader
          rectAttributes={CommonComponentLoaderAttribute}
          showError={showError}
          setShowError={setShowError}
        />
      ) : (
        <Box className="content-div">
          <div>
            <Autocomplete
              multiple
              id="tags-filled"
              key={backToDefault}
              disableClearable={true}
              onChange={handleChange}
              options={[]}
              defaultValue={[]}
              freeSolo
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip label={option} {...getTagProps({ index })} />
                ))
              }
              renderInput={(params) => (
                <div className="margin-bottom-form">
                  <TextField
                    {...params}
                    error={isError}
                    required
                    onChange={handleInputChange}
                    id="standard-required"
                    label={name}
                    sx={{ width: '35vw', margin: '0px 5px 10px 10px' }}
                    variant="outlined"
                    placeholder={'Add ' + name}
                  />
                  <LoadingButton
                    type="submit"
                    variant="contained"
                    loading={loadingApiCall}
                    sx={{ margin: '8px 0px 0px 55px' }}
                    onClick={() => onAddClick()}
                  >
                    {loadingApiCall ? 'loading...' : 'Add ' + name}
                  </LoadingButton>
                </div>
              )}
            />
          </div>
          <div style={{ marginTop: '2vw' }}>
            {titlesList.map((item) => (
              <CustomChip
                key={item.id}
                size={0.9}
                label={
                  item?.designationNames ? item.designationNames[0] : item.name
                }
                onDelete={() => handleDelete(item)}
              />
            ))}
          </div>
        </Box>
      )}
    </div>
  );
}

export default CommonComponent;
